<template>
  <div class="liveVidwH5">
    <div class="videoPlayBox"  >
      <div style="width: 100%; height: 233px;background-color:#000000">
        <div class="zs-live-broadcast">
          <!-- <div v-if="tvType == 5">
                        <div class="liveBroadcastState"
                            :style="{ background: liveBroadcastSwitch.liveBroadcastState == 0 ? 'rgba(58, 131, 255,.6)' : liveBroadcastSwitch.liveBroadcastState == 1 ? '#FFA43A' : 'rbga(66, 80, 107,.6)' }"
                            style="position: absolute;z-index: 2001;left:20px;top:20px;">
                            {{
                        liveBroadcastSwitch.liveBroadcastState == 0 ? '未开始' :
                            liveBroadcastSwitch.liveBroadcastState == 1 ? '直播中' :
                                liveBroadcastSwitch.liveBroadcastState == 2 ? '已结束' : '回看'
                    }}
                        </div>
                    </div> -->

          <!-- <div class="lickVideo" style="position: absolute;z-index: 2001;left:120px;top:20px;"
                        v-if="liveBroadcastSwitch.livePeopleSwitch && liveBroadcastSwitch.liveBroadcastState">
                        {{ liveBroadcastSwitch.livePeopleType == 1 ? '实时在线' : '累计观看' }} {{ formattedNumber(people) }}
                    </div> -->
          <!-- <div class="lickVideo" style="position: absolute;top:20px;right:40px;z-index:2001;"
                        v-if="liveDataInfo.liveLikeSwitch">
                        <span>本场点赞 {{ formattedNumber(likeCount) }}</span>
                    </div> -->
          <div v-if="
            liveBroadcastSwitch.liveBroadcastState == 1 ||
            $route.query.tvid == 2
          ">
            <VueAliplayerV2 style="width: 100%;" class="video" v-if="!noplay && isM3u8" :options="option"
              ref="VueAliplayerV2" :sourceUrl="source" :livePwId="liveDataInfo.livePwId"
              :liveTimeShiftFlag="liveTimeShiftFlag" :resolutionSwitch="resolutionSwitch" @fullScreen="fullScreen">
            </VueAliplayerV2>
            <flvVideoJs ref="flvVideoJs" :url="source" v-if="!noplay && !isM3u8" :liveTimeShiftFlag="false"
              :resolutionSwitch="resolutionSwitch" />
            <div class="multiCamera" @click.stop="camera(true)">
              <img src="@/assets/zsLiveImage/h5/multiCamera.png" alt="">
            </div>
          </div>
          <div style="width:100%;height:100%;" v-if="videoPreShow">
            <video width="100%" height="100%" controls autoplay muted webkit-playsinline="true" playsinline='true'
              x5-video-player-type="h5-page">
              <source :src="videoUrl" type="video/mp4" />
            </video>
            <div class="countdownBanner" v-if="liveBroadcastSwitch.liveCountDownSwitch == 1 && videoPreShow">
              <span style="font-size:12px;color:#fff;width:105px;white-space: nowrap;">
                距离直播开始还有
              </span>
              <div style="display:flex;align-items:center;justify-content: space-between;margin-top:5px;width:105px">
                <span class="timer">{{ time.h }}</span>
                <span class="timerSymbol">:</span>
                <span class="timer">{{ time.m }}</span>
                <span class="timerSymbol">:</span>
                <span class="timer">{{ time.s }}</span>
              </div>
            </div>
            <div>

            </div>
          </div>
          <video width="100%" height="100%" controls autoplay muted webkit-playsinline="true" playsinline='true'
            x5-video-player-type="h5-page" v-if="liveBroadcastSwitch.liveBroadcastState != 1 && videoBackShow">
            <source :src="videoUrl" type="video/mp4" />
          </video>

          <div class="un-zs-live-broadcast" v-if="occupyBitmap">
            <img :src="returnImgPath(liveDataInfo.liveActivityImage)" alt="" style="width: 100%; height: 100%" />
            <div class="countDown" v-if="liveBroadcastSwitch.liveBroadcastState == 2">
              <div class="photo">
                <img src="@/assets/zsLiveImage/yjs.png" alt="" />
              </div>
            </div>
            <div class="countDown" v-if="liveBroadcastSwitch.liveBroadcastState == 0">
              <div v-if="liveBroadcastSwitch.liveCountDownSwitch == 1">
                <div class="countDownBox">
                  <div class="title">距离直播开始还有</div>
                  <div class="countDownTime">
                    <span class="pubTime">{{ time.h }}</span>
                    <span> 小时 </span>
                    <span class="pubTime">{{ time.m }}</span>
                    <span> 分 </span>
                    <span class="pubTime">{{ time.s }}</span>
                    <span>秒</span>
                  </div>
                </div>
              </div>
              <div class="photo" v-if="liveBroadcastSwitch.liveCountDownSwitch == 0">
                <img src="@/assets/zsLiveImage/wks.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="videoDetails">
      <div class="title">
        {{
          liveDataInfo.liveActivityTitle ||
          liveDataInfo.liveTvName ||
          liveDataInfo.liveTrafficTitle
        }}
      </div>
      <div class="personAndStatus"
        v-if="liveDataInfo.livePeopleSwitch || (liveBroadcastSwitch.liveBroadcastState == 3 || liveBroadcastSwitch.liveBroadcastState == 1)">
        <div
          v-if="(liveBroadcastSwitch.liveBroadcastState == 1 || liveBroadcastSwitch.liveBroadcastState == 3)&&liveDataInfo.livePeopleSwitch==0">
        </div>
        <div class="person" v-if="liveDataInfo.livePeopleSwitch">
          <span class="watchPeople">观看人数</span>
          <span class="watchPeopleNum"> {{ people }} 人</span>
        </div>
        <div class="videoStatus" :style="{
          background:
              liveBroadcastSwitch.liveBroadcastState == 1
                ? '#ff4545'
                : '#FFEEE4',
            color:liveBroadcastSwitch.liveBroadcastState == 3?'#FF6107':'',
          }" v-if="liveBroadcastSwitch.liveBroadcastState != 0 && liveBroadcastSwitch.liveBroadcastState != 2">
          <img src="@/assets/zsLiveImage/zhibo.png" alt="" v-if="liveBroadcastSwitch.liveBroadcastState == 1" />
          <span>
            {{
            liveBroadcastSwitch.liveBroadcastState == 0
            ? "未开始"
            : liveBroadcastSwitch.liveBroadcastState == 1
            ? "直播中"
            : liveBroadcastSwitch.liveBroadcastState == 2
            ? "已结束"
            : "回看"
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueAliplayerV2 from "@/components/ckPlayerLiveShareHiden.vue";
import flvVideoJs from "@/components/player/flvJs.vue";
import { filePerviewPath } from "@/api/globalApi.js";
import {
  activityDetailNotoken,
  getPeople,
  activityGetLike,
  activityLike,
  livetrafficPreviewNotoken,
} from "@/api/liveView/activity.js";
export default {
  data() {
    return {
      tvType: 5, // 地址类型
      liveBroadcastSwitch: {
        liveBroadcastState: null, // 直播状态 0 未开始 1 直播中 2 已结束 3 回放
        livePeopleType: 0, // 人数展示形式 0 累计人数 1 实时在线人数
        livePeopleSwitch: 0, // 在线人数统计 0 不显示 1 显示
        liveCountDownSwitch: 0, // 直播倒计时
      },
      liveDataInfo: {},
      videoBackShow: false, // 直播回放
      videoPreShow: false, // 直播垫片
      occupyBitmap: true, // 占位图
      likeCount: 0, // 点赞人数、
      option: {
        isLive: true, //切换为直播流的时候必填
        width: "100%",
        height: "100%",
        showBarTime: 3000,
      },
      source: "", // 流地址
      noplay: true, // 是否播放
      isM3u8: false, // 推流 m3u8
      videoUrl: "", // 垫片或者回放地址
      liveTimeShiftFlag: false, // 是否开启时移
      resolutionSwitch: false,
      people: 0, // 在线人数
      giftListSend: [], // 礼物列表
      // 倒计时
      time: {
        h: "", // 小时
        m: "", // 分钟
        s: "", // 秒
      },
    };
  },
  watch: {
    tvLivetime(value) {
      if (value < 0) {
        // this.livePwState=1
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    interval(value) {
      if (!value) {
        this.getList(this.tvId);
      }
    },
  },
  components: {
    flvVideoJs,
    VueAliplayerV2,
  },
  mounted() {
    this.tvId = this.$route.query.tvid;
    // 获取分享地址
    if (this.$route.query.tvType > 5) {
      if (this.$route.query.tvType == 6) {
        this.tvType = 1;
      } else if (this.$route.query.tvType == 7) {
        this.tvType = 2;
      } else if (this.$route.query.tvType == 8) {
        this.tvType = 5;
      } else if (this.$route.query.tvType == 10) {
        this.tvType = 3;
      } else if (this.$route.query.tvType == 16) {
        this.tvType = 4;
      }
    } else {
      this.tvType = this.$route.query.tvType;
    }
    // 获取直播详情
    if (this.tvType == 5) {
      this.getList(this.tvId);
    } else if (this.tvType == 4) {
      this.getLivetraffic(this.tvId);
    } else {
      this.getTvDetail(this.tvId);
      // this.ontimechange(new Date());
    }
    window.onresize = () => {
      this.clientWidth = document.body.clientWidth;
    };
  },
  methods: {
    // 获取图片地址
    returnImgPath(id) {
      if (!id) {
        // return require("@/assets/img/fileicon/noImg.png");
      } else {
        let params = {
          fileObjId: id,
          downType: "cover",
        };
        return filePerviewPath(params);
      }
    },
    //获取直播详情
    getList(liveActivityId) {
      this.pageLoad = true;
      clearInterval(this.peopleinterval);
      this.peopleinterval = null;
      let obj = {
        liveActivityId: Number(liveActivityId),
      };
      activityDetailNotoken(obj)
        .then(({ data }) => {
          this.pageLoad = false;
          if (data.code == 200) {
            this.liveDataInfo = data.data;
            this.setLiveDataInfo(this.liveDataInfo);
            this.liveDataInfo.coverimgPath = filePerviewPath({
              downType: "resource",
              fileObjId: data.data.liveActivityImage,
            });
            if (data.data.liveActivityFrameEntityList.length > 0) {
              this.liveDataInfo.liveFrameImage =
                data.data.liveActivityFrameEntityList[0].liveFrameImage;
            } else {
              this.liveDataInfo.liveFrameImage = data.data.liveActivityImage;
            }
            // 多机位展示list
            this.cameraList = this.liveDataInfo.liveActivityFrameEntityList;
            if (this.cameraList.length > 0) {
              this.cameraList[0].active = true;
            }
            this.sumStatus();
            this.liveBroadcastSwitch.livePeopleType = data.data.livePeopleType;
            this.liveBroadcastSwitch.livePeopleSwitch =
              data.data.livePeopleSwitch;
            this.liveBroadcastSwitch.liveCountDownSwitch =
              data.data.liveCountDownSwitch;
            if (this.liveBroadcastSwitch.liveCountDownSwitch) {
              this.handleDownTimeH5(this.liveDataInfo.liveActivityBeginTime);
            }
            this.livetime = data.data.liveActivityBeginTime;
            this.liveCountDownSwitch = data.data.liveCountDownSwitch; // 倒计时开关
            this.livePeopleSwitch = data.data.livePeopleSwitch;
            this.livetitle = data.data.liveActivityTitle;
            this.livePwState = data.data.livePwState; // 直播状态
            
            // this.giftListSend = data.data.liveActivityPropEntityList;
            this.setGiftListSend(data.data.liveActivityPropEntityList);
            this.recommendList = data.data.liveActivityRecommendEntityList; // 推荐列表
            this.$forceUpdate();
            this.createTime = data.data.createTime;
            this.startime =
              Date.parse(new Date(data.data.liveActivityBeginTime)) -
              parseInt(Date.now());
            this.countDownTimePlay =
              Date.parse(new Date(data.data.liveActivityBeginTime)) -
              parseInt(Date.now());
            if (this.countDownTimePlay > 0) {
              this.handleDownTimeH5(this.liveDataInfo.liveActivityBeginTime);
            }
            if (this.startime > 0) {
              setTimeout(() => {
                setTimeout(() => {
                  this.getList(liveActivityId);
                }, 1000);
              }, this.startime);
            }
            this.endtime =
              Date.parse(new Date(data.data.liveActivityEndTime)) -
              parseInt(Date.now());
            if (this.endtime > 0) {
              setTimeout(() => {
                this.getList(liveActivityId);
              }, this.endtime);
            }
            if (this.livePeopleSwitch !== 0) {
              this.getLike(this.$route.query.tvid);
              this.getPeopleFunc(this.$route.query.webSoleId);
              this.peopleinterval = setInterval(() => {
                this.getPeopleFunc(this.$route.query.webSoleId);
                this.getLike(this.$route.query.tvid);
                if (this.addLikeNum > 0) {
                  this.addLike();
                }
              }, 10000);
            }
            // 多机位
            if (this.liveDataInfo.liveMultiCamera == 0) {
              // livePwState  1 推流中 2 拉流中 3无直播流 4 转推失败 5 拉流失败
              // livePwType 0 拉流 1 推流
              // liveState  0未开始 1直播中 2已结束
              this.livePwState = this.liveDataInfo.livePwState;
              this.liveDataInfo.liveActivityFrameEntityList[0].active = true;
              //推流
              if (
                this.liveDataInfo.liveActivityFrameEntityList[0].livePwType == 1
              ) {
                if (
                  this.liveDataInfo.liveActivityFrameEntityList[0]
                    .livePwState === 1
                ) {
                  if (
                    this.liveDataInfo.liveActivityFrameEntityList[0]
                      .livePwState === 1
                  ) {
                    // 直播进行中
                    this.isM3u8 = true;
                    this.noplay = false;
                    this.occupyBitmap = false;
                    this.source =
                      this.liveDataInfo.liveActivityFrameEntityList[0].liveHlsPlayPath;
                    this.pullPath =
                      this.liveDataInfo.liveActivityFrameEntityList[0].liveRtmpPushPath;
                  } else {
                    // 直播未开始
                    this.noplay = false;
                    if (
                      this.liveDataInfo.livePlaybackFlag == 1 &&
                      this.liveBroadcastSwitch.liveBroadcastState == 3
                    ) {
                      this.videoBackShow = true;
                      this.videoPreShow = false;
                      this.occupyBitmap = false;
                    } else if (
                      this.liveDataInfo.livePreFileFlag == 1 &&
                      this.liveBroadcastSwitch.liveBroadcastState == 0
                    ) {
                      this.videoPreShow = true;
                      this.videoBackShow = false;
                      this.occupyBitmap = false;
                    } else {
                      this.occupyBitmap = true;
                      this.videoBackShow = false;
                      this.videoPreShow = false;
                    }
                  }
                }
                // 拉流
              } else if (
                this.liveDataInfo.liveActivityFrameEntityList[0].livePwType == 0
              ) {
                // 拉流 转推 liveRetweetedFlag = 1 取 liveHlsPlayPath, 不转推 liveRetweetedFlag = 0 取   pullPath
                // 转推
                if (
                  this.liveDataInfo.liveActivityFrameEntityList[0]
                    .liveRetweetedFlag == 1
                ) {
                  // 拉流中
                  if (
                    this.liveDataInfo.liveActivityFrameEntityList[0]
                      .livePwState === 2
                  ) {
                    // 直播进行中
                    if (
                      this.liveDataInfo.liveActivityFrameEntityList[0]
                        .livePwState === 1
                    ) {
                      this.noplay = false;
                      this.occupyBitmap = false;
                      this.source =
                        this.liveDataInfo.liveActivityFrameEntityList[0].liveHlsPlayPath;
                      this.pullPath =
                        this.liveDataInfo.liveActivityFrameEntityList[0].liveRtmpPushPath;
                      if (this.source.indexOf("flv") !== -1) {
                        this.isM3u8 = false;
                      } else {
                        this.isM3u8 = true;
                      }
                    } else {
                      // 直播未开始
                      this.noplay = false;
                      if (
                        this.liveDataInfo.livePlaybackFlag == 1 &&
                        this.liveBroadcastSwitch.liveBroadcastState == 3
                      ) {
                        this.videoBackShow = true;
                        this.videoPreShow = false;
                        this.occupyBitmap = false;
                      } else if (
                        this.liveDataInfo.livePreFileFlag == 1 &&
                        this.liveBroadcastSwitch.liveBroadcastState == 0
                      ) {
                        this.videoPreShow = true;
                        this.videoBackShow = false;
                        this.occupyBitmap = false;
                      } else {
                        this.occupyBitmap = true;
                        this.videoBackShow = false;
                        this.videoPreShow = false;
                      }
                    }
                  }
                } else {
                  // 不转推
                  // 拉流中

                  if (
                    this.liveDataInfo.liveActivityFrameEntityList[0]
                      .livePwState === 2
                  ) {
                    // 直播中
                    if (this.liveDataInfo.liveState == 1) {
                      this.noplay = false;
                      this.occupyBitmap = false;
                      this.source =
                        this.liveDataInfo.liveActivityFrameEntityList[0].livePullPath;
                      this.pullPath =
                        this.liveDataInfo.liveActivityFrameEntityList[0].liveRtmpPushPath;
                      if (this.source.indexOf("flv") !== -1) {
                        this.isM3u8 = false;
                      } else {
                        this.isM3u8 = true;
                      }
                    } else {
                      this.noplay = false;
                      if (
                        this.liveDataInfo.livePlaybackFlag == 1 &&
                        this.liveBroadcastSwitch.liveBroadcastState == 3
                      ) {
                        this.videoBackShow = true;
                        this.videoPreShow = false;
                        this.occupyBitmap = false;
                      } else if (
                        this.liveDataInfo.livePreFileFlag == 1 &&
                        this.liveBroadcastSwitch.liveBroadcastState == 0
                      ) {
                        this.videoPreShow = true;
                        this.videoBackShow = false;
                        this.occupyBitmap = false;
                      } else {
                        this.occupyBitmap = true;
                        this.videoBackShow = false;
                        this.videoPreShow = false;
                      }
                    }
                  } else {
                    // 直播未开始
                    this.noplay = true;
                    if (
                      this.liveDataInfo.livePlaybackFlag == 1 &&
                      this.liveBroadcastSwitch.liveBroadcastState == 3
                    ) {
                      this.videoBackShow = true;
                      this.videoPreShow = false;
                      this.occupyBitmap = false;
                    } else if (
                      this.liveDataInfo.livePreFileFlag == 1 &&
                      this.liveBroadcastSwitch.liveBroadcastState == 0
                    ) {
                      this.videoPreShow = true;
                      this.videoBackShow = false;
                      this.occupyBitmap = false;
                    } else {
                      this.occupyBitmap = true;
                      this.videoBackShow = false;
                      this.videoPreShow = false;
                    }
                  }
                }
              }
            } else if (this.liveDataInfo.liveMultiCamera == 1) {
              // 单机位
              // livePwState  1 推流中 2 拉流中 3无直播流 4 转推失败 5 拉流失败
              // livePwType 0 拉流 1 推流
              // liveState  0未开始 1直播中 2已结束
              this.livePwState = this.liveDataInfo.livePwState;
              // 推流直播
              if (this.liveDataInfo.livePwType == 1) {
                this.isM3u8 = true;
                // 推流中
                if (this.liveDataInfo.livePwState === 1) {
                  // 直播中
                  if (this.liveDataInfo.liveState == 1) {
                    this.noplay = false;
                    this.occupyBitmap = false;
                    this.source = this.liveDataInfo.liveHlsPlayPath;
                    this.pullPath = this.liveDataInfo.liveRtmpPushPath;
                    // 未开始直播
                  } else {
                    this.noplay = true;
                    if (
                      this.liveDataInfo.livePlaybackFlag == 1 &&
                      this.liveBroadcastSwitch.liveBroadcastState == 3
                    ) {
                      this.videoBackShow = true;
                      this.videoPreShow = false;
                      this.occupyBitmap = false;
                    } else if (
                      this.liveDataInfo.livePreFileFlag == 1 &&
                      this.liveBroadcastSwitch.liveBroadcastState == 0
                    ) {
                      this.videoPreShow = true;
                      this.videoBackShow = false;
                      this.occupyBitmap = false;
                    } else {
                      this.occupyBitmap = true;
                      this.videoBackShow = false;
                      this.videoPreShow = false;
                    }
                  }
                } else {
                  this.noplay = true;
                  if (
                    this.liveDataInfo.livePlaybackFlag == 1 &&
                    this.liveBroadcastSwitch.liveBroadcastState == 3
                  ) {
                    this.videoBackShow = true;
                    this.videoPreShow = false;
                    this.occupyBitmap = false;
                  } else if (
                    this.liveDataInfo.livePreFileFlag == 1 &&
                    this.liveBroadcastSwitch.liveBroadcastState == 0
                  ) {
                    this.videoPreShow = true;
                    this.videoBackShow = false;
                    this.occupyBitmap = false;
                  } else {
                    this.occupyBitmap = true;
                    this.videoBackShow = false;
                    this.videoPreShow = false;
                  }
                }
                // 拉流
              } else if (this.liveDataInfo.livePwType == 0) {
                //  转推 liveRetweetedFlag = 1 取 liveHlsPlayPath, 不转推 liveRetweetedFlag = 0 取   pullPath
                if (this.liveDataInfo.liveRetweetedFlag == 1) {
                  // 转推 拉流中
                  if (this.livePwState === 2) {
                    // 直播中
                    if (this.liveDataInfo.liveState == 1) {
                      this.source = this.liveDataInfo.liveHlsPlayPath;
                      this.noplay = false; // 隐藏展位图
                      this.occupyBitmap = false;
                      if (this.source.indexOf("flv") !== -1) {
                        this.isM3u8 = false;
                      } else {
                        this.isM3u8 = true;
                      }
                      if (
                        this.liveDataInfo.livePlaybackFlag == 1 &&
                        this.liveBroadcastSwitch.liveBroadcastState == 3
                      ) {
                        this.videoBackShow = true;
                        this.videoPreShow = false;
                        this.occupyBitmap = false;
                      } else if (
                        this.liveDataInfo.livePreFileFlag == 1 &&
                        this.liveBroadcastSwitch.liveBroadcastState == 0
                      ) {
                        this.videoPreShow = true;
                        this.videoBackShow = false;
                        this.occupyBitmap = false;
                      } else {
                        this.occupyBitmap = true;
                        this.videoBackShow = false;
                        this.videoPreShow = false;
                      }
                    }
                  } else {
                    // 直播未开始
                    this.noplay = false;
                    if (
                      this.liveDataInfo.livePlaybackFlag == 1 &&
                      this.liveBroadcastSwitch.liveBroadcastState == 3
                    ) {
                      this.videoBackShow = true;
                      this.videoPreShow = false;
                      this.occupyBitmap = false;
                    } else if (
                      this.liveDataInfo.livePreFileFlag == 1 &&
                      this.liveBroadcastSwitch.liveBroadcastState == 0
                    ) {
                      this.videoPreShow = true;
                      this.videoBackShow = false;
                      this.occupyBitmap = false;
                    } else {
                      this.occupyBitmap = true;
                      this.videoBackShow = false;
                      this.videoPreShow = false;
                    }
                  }
                } else {
                  // 不转推 拉流中
                  if (this.livePwState === 2) {
                    // 直播中
                    if (this.liveDataInfo.liveState == 1) {
                      this.source = this.liveDataInfo.livePullPath;
                      this.noplay = false; // 隐藏展位图
                      this.occupyBitmap = false;
                      if (this.source.indexOf("flv") !== -1) {
                        this.isM3u8 = false;
                      } else {
                        this.isM3u8 = true;
                      }
                    } else {
                      if (
                        this.liveDataInfo.livePlaybackFlag == 1 &&
                        this.liveBroadcastSwitch.liveBroadcastState == 3
                      ) {
                        this.videoBackShow = true;
                        this.videoPreShow = false;
                        this.occupyBitmap = false;
                      } else if (
                        this.liveDataInfo.livePreFileFlag == 1 &&
                        this.liveBroadcastSwitch.liveBroadcastState == 0
                      ) {
                        this.videoPreShow = true;
                        this.videoBackShow = false;
                        this.occupyBitmap = false;
                      } else {
                        this.occupyBitmap = true;
                        this.videoBackShow = false;
                        this.videoPreShow = false;
                      }
                    }
                  } else {
                    // 直播未开始
                    this.noplay = false;
                    if (
                      this.liveDataInfo.livePlaybackFlag == 1 &&
                      this.liveBroadcastSwitch.liveBroadcastState == 3
                    ) {
                      this.videoBackShow = true;
                      this.videoPreShow = false;
                      this.occupyBitmap = false;
                    } else if (
                      this.liveDataInfo.livePreFileFlag == 1 &&
                      this.liveBroadcastSwitch.liveBroadcastState == 0
                    ) {
                      this.videoPreShow = true;
                      this.videoBackShow = false;
                      this.occupyBitmap = false;
                    } else {
                      this.occupyBitmap = true;
                      this.videoBackShow = false;
                      this.videoPreShow = false;
                    }
                  }
                }
              }
            }

            this.tvLivetime =
              this.liveDataInfo.liveActivityBeginTime - new Date();
            if (this.tvLivetime >= 0) {
              this.interval = setInterval(() => {
                this.tvLivetime -= 1000;
                this.getTime(this.tvLivetime);
              }, 1000);
            }
            this.$forceUpdate();
          }
        })
        .catch(() => {
          this.pageLoad = false;
        });
    },
    // 计算当前直播状态
    sumStatus() {
      let date = new Date(this.liveDataInfo.liveActivityBeginTime);
      let date1 = new Date(this.liveDataInfo.liveActivityEndTime);
      if (date - new Date() > 0) {
        this.liveBroadcastSwitch.liveBroadcastState = 0;
        this.videoUrl = this.getVideoPath(this.liveDataInfo.livePreFileId);
      } else if (date - new Date() < 0) {
        this.liveBroadcastSwitch.liveBroadcastState = 1;
      }
      if (date1 - new Date() < 0) {
        this.liveBroadcastSwitch.liveBroadcastState = 2;
      }
      if (
        this.liveBroadcastSwitch.liveBroadcastState == 2 &&
        this.liveDataInfo.livePlaybackFlag == 1
      ) {
        this.liveBroadcastSwitch.liveBroadcastState = 3;
        // this.videoUrl = this.getVideoPath(this.liveDataInfo.liveRecordFileId);
        if (this.liveDataInfo.liveRecordFileType == 0) {
          this.videoUrl = this.getVideoPath(this.liveDataInfo.liveRecordFileId);
        } else {
          this.videoUrl = this.liveDataInfo.liveRecordFilePath
        }
      }
    },
    // 人数补k
    formattedNumber(val) {
      if (val >= 1000) {
        const k = (val / 1000).toFixed(1);
        return `${k} K`;
      } else if (val >= 10000) {
        const k = (val / 10000).toFixed(1);
        return `${k} w`;
      } else {
        return val;
      }
    },
    // 获取点赞数
    getLike(val) {
      activityGetLike({ liveAboutId: val, liveAboutType: 5 }).then((res) => {
        if (res.data.code == 200) {
          this.likeCount = res.data.data.sumCount;
        }
      });
    },
    // 获取在线人数
    getPeopleFunc(webSoleId) {
      getPeople({ webSoleId: this.$route.query.webSoleId }).then(({ data }) => {
        if (data.code == 200) {
          this.people = data.data;
        }
      });
    },
    // 获取视频地址
    getVideoPath(item) {
      return filePerviewPath({ downType: "resource", fileObjId: item });
    },
    // 直播倒计时
    handleDownTimeH5(ele) {
      var that = this;
      var interval = setInterval(function timestampToTime() {
        let endDate = new Date(ele)
        let endtime = endDate.getTime()
        var date = parseInt((endtime - new Date().getTime()) / 1000); //计算剩余的毫秒数
        if (date == 0 || date < 0) {
          that.isEnd = true;
          if(that.isEnd){
            location.reload()
            that.isEnd = false;
          }
          clearInterval(interval);
        } else {
          that.time.D = parseInt(date / 60 / 60 / 24);
          that.time.h = parseInt((date / 60 / 60) % 24);
          if (that.time.D > 0) {
            that.time.h = that.time.D * 24 + that.time.h
          } else {
            that.time.h = that.time.h < 10 ? "0" + that.time.h : that.time.h
          }
          // if (that.time.h < 10) {
          //   that.time.h = "0" + that.time.h;
          // }
          that.time.m = parseInt((date / (60)) % 60); //计算剩余的分钟
          if (that.time.m < 10) {
            that.time.m = "0" + that.time.m;
          }
          that.time.s = parseInt((date) % 60); //计算剩余的秒数
          if (that.time.s < 10) {
            that.time.s = "0" + that.time.s;
          }
          // return that.time.D+that.time.h+that.time.m+that.time.s;
        }
      }, 1000);
    },
    // 获取电视节目单
    getNextDate(date, day) {
      var dd = new Date(date);
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    // 回传直播信息
    setLiveDataInfo(ele) {
      this.$emit("liveDataInfo", ele);
    },
    // 回传礼物列表
    setGiftListSend(ele) {
      this.$emit("giftListSend", ele);
    },
    // 判断是否为全屏
    fullScreen(ele) {
      console.log(ele, '816');
    },
    // 多机位切换
    camera(ele) {
      this.$emit('cameraChange', ele)
    }
  },
};
</script>

<style scoped lang="scss">
@import "./zscmsLiveMixin.scss";

.liveVidwH5 {
  position: relative;
  width: 100%;
  height: 320px;
  font-size: 16px;
  .videoPlayBox {
    width: 100%;
  }

  .videoDetails {
    width: 100%;
    box-sizing: border-box;
    padding: 16px;

    .title {
      font-size: 18px;
      font-weight: bold;
    }

    .personAndStatus {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 34px;

      .watchPeople {
        color: #666666;
        font-size: 14px;
      }

      .watchPeopleNum {
        font-size: 12px;
        font-weight: bold;
        margin-left: 10px;
      }

      .videoStatus {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px;
        height: 24px;
        font-size: 14px;
        color: #fff;
        text-align: center;
        background-color: #ff4545;
        border-radius: 20px;

        img {
          margin-right: 5px;
        }
      }
    }
  }

  .tabs-click {
    width: 100%;
    height: 500px;
  }

  /deep/ .popper__arrow {
    left: 300px;
  }
}

.multiCamera {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 10px;
  top: 45%;
  transform: translateY(-50%);
  z-index: 100;
}

.zs-live-broadcast {
  position: relative;
  height: 233px;
  width: 100%;

  .un-zs-live-broadcast {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 2000;
    background-color: rgba(6, 29, 62, 1);
    overflow: hidden;

    .countDown {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);

      .photo {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 140px;
          height: 140px;
        }
      }

      .countDownBox {
        width: 100%;
        height: 100%;
        padding-top: 80px;
        box-sizing: border-box;

        .title {
          color: #fff;
          font-weight: bold;
          text-align: center;
        }
      }

      .countDownTime {
        margin-top: 12px;
        width: 100%;
        color: #fff;
        text-align: center;

        .pubTime {
          font-size: 36px;
        }
      }
    }
  }

  .countdownBanner {
    position: absolute;
    top: 12px;
    left: 12px;
    width: 25%;
    height: 40px;
    text-align: center;

    .timer {
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 14px;
      background-color: #d42424;
      border-radius: 2px;
      color: #fff;
    }

    .timerSymbol {
      display: inline-block;

      width: 10px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 2px;
      background-color: #d42424;
      color: #fff;
    }
  }
}
</style>